import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const Holder = styled.div<{ $isShrunk?: boolean }>`
    width: 100%;
    margin: auto;
    position: relative;

    display: flex;
    flex-direction: column-reverse;
    transition: border-top 0.2s ease;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        gap: 50px;
    }

    ${({ $isShrunk }) => {
        if ($isShrunk) {
            return css`
                border-top: 1px solid rgba(255, 255, 255, 0);
            `;
        }
    }}
`;

export const HeaderNavButton = styled.div<{ $isActive?: boolean; $disabled?: boolean; $small?: boolean }>`
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0.5;
    transition: all 0.2s ease;
    user-select: none;

    font-weight: 700;
    line-height: 100%;
    color: #ffffff;
    font-size: 14px;
    padding: 0 5px;

    white-space: nowrap;

    ${({ $disabled }) =>
        $disabled &&
        css`
            opacity: 0.2;
            pointer-events: none;
        `};
    ${({ $isActive }) =>
        $isActive &&
        css`
            opacity: 1;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-bottom: 40px;
        overflow: unset;
        width: auto;
        height: auto;
        font-size: 18px;
        max-width: 128px;
        ${({ $small }) =>
            $small &&
            css`
                padding-bottom: 15px;
                max-width: unset;
            `};
    }
`;

export const ButtonWrapper = styled.div<{ $small?: boolean }>`
    display: inline-flex;
    gap: 20px;
    position: relative;

    width: 100%;
    height: 43px;

    overflow: hidden;
    overflow-x: auto;

    scrollbar-width: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    scroll-behavior: smooth;
    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        overflow: unset;
        width: auto;
        height: auto;
        gap: 40px;
        ${({ $small }) =>
            $small &&
            css`
                gap: 15px;
                margin-bottom: 10px;
            `};
    }
`;

export const ActiveLine = styled(motion.div)`
    pointer-events: none;
    content: '';
    display: block;
    width: 0;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    opacity: 0;
`;
